export function getPrivateSubmissionAppOrigin() {
    const origin = process.env.PRIVATE_SUBMISSION_URL;
    if (!origin) {
        return '';
    }
    try {
        return new URL(origin).origin;
    }
    catch {
        return '';
    }
}
export function privateSubmissionUrl(path) {
    const origin = getPrivateSubmissionAppOrigin().replace(/\/$/, '');
    if (!origin) {
        return '';
    }
    const token = process.env.CRM_TOKEN;
    return `${origin}/private-submission/${path}?crm_token=${token}`;
}
